/* 3OS 269 · format-first direct checkout.
   Native links remain the no-JS fallback; enhancement owns only the dialog. */
(function () {
  'use strict';
  if (window.__tos269QuickBuy) return;
  window.__tos269QuickBuy = true;

  var dialog = document.querySelector('[data-r2-quick-buy-dialog]');
  if (!dialog) return;

  var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-r2-quick-buy-open]'));
  var closeButton = dialog.querySelector('[data-r2-quick-buy-close]');
  var heading = dialog.querySelector('[tabindex="-1"]');
  var returnTo = null;

  function setExpanded(value) {
    triggers.forEach(function (trigger) { trigger.setAttribute('aria-expanded', value ? 'true' : 'false'); });
  }

  function setLock(value) {
    if (window.tosR2Lock) {
      if (value) window.tosR2Lock.add('quick-buy');
      else window.tosR2Lock.remove('quick-buy');
      return;
    }
    document.body.classList.toggle('tos-r2-locked', value);
  }

  function show(trigger) {
    returnTo = trigger || null;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    setExpanded(true);
    setLock(true);
    if (heading && heading.focus) heading.focus({ preventScroll: true });
  }

  function close() {
    if (dialog.open && typeof dialog.close === 'function') dialog.close();
    else {
      dialog.removeAttribute('open');
      dialog.dispatchEvent(new Event('close'));
    }
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (typeof dialog.showModal !== 'function') return;
      event.preventDefault();

      var menu = document.querySelector('[data-r2-menu-dialog]');
      if (menu && menu.open) {
        menu.addEventListener('close', function () { window.requestAnimationFrame(function () { show(trigger); }); }, { once: true });
        menu.close();
      } else {
        show(trigger);
      }
    }, true);
  });

  if (closeButton) closeButton.addEventListener('click', close);
  dialog.addEventListener('click', function (event) { if (event.target === dialog) close(); });
  dialog.addEventListener('close', function () {
    var focusTarget = returnTo;
    setExpanded(false);
    setLock(false);
    returnTo = null;
    if (focusTarget && focusTarget.focus && document.contains(focusTarget)) {
      focusTarget.focus({ preventScroll: true });
      window.requestAnimationFrame(function () {
        if (!dialog.open && document.contains(focusTarget)) focusTarget.focus({ preventScroll: true });
      });
    }
  });
})();
